module.exports = __webpack_public_path__ + "static/slider-perks-img3-73ac14dbdbb086a5cc9b6ff741c9d80d.jpeg";